module.exports = __webpack_public_path__ + "static/assets/e2011e5d1ce743841c0080ff3a62dc0e.svg";